import { Instagram } from "lucide-react";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE, INSTAGRAM_IMAGES } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const InstagramFeed = () => (
    <section id="instagram" data-testid="instagram-section" className="scroll-mt-20 border-t border-gold/20 bg-ink py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal className="text-center">
                <p className="text-xs font-bold uppercase tracking-[0.3em] text-gold">
                    05 · Antes y después, cada semana
                </p>
                <h2 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
                    Síguenos en Instagram
                </h2>
                <a
                    href={INSTAGRAM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="instagram-handle-link"
                    className="mt-4 inline-block text-base font-bold text-gold transition-colors duration-200 hover:text-white"
                >
                    {INSTAGRAM_HANDLE}
                </a>
            </Reveal>

            <div className="mt-14 grid grid-cols-2 gap-2 md:grid-cols-3" data-testid="instagram-grid">
                {INSTAGRAM_IMAGES.map((src, index) => (
                    <a
                        key={src}
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`instagram-image-${index + 1}`}
                        className="group relative block aspect-square overflow-hidden rounded-sm"
                    >
                        <img
                            src={src}
                            alt={`Trabajo de detailing de Rey Detailing ${index + 1}`}
                            loading="lazy"
                            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                        <span className="absolute inset-0 flex items-center justify-center bg-ink/60 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                            <Instagram className="h-8 w-8 text-white" />
                        </span>
                    </a>
                ))}
            </div>

            <Reveal className="mt-12 text-center">
                <a
                    href={INSTAGRAM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="instagram-view-btn"
                    className="inline-flex items-center justify-center gap-2 rounded-sm border border-white/40 px-8 py-4 text-base font-bold text-white transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-white/10"
                >
                    <Instagram className="h-5 w-5" />
                    Ver Instagram
                </a>
            </Reveal>
        </div>
    </section>
);
